import React from 'react'
import Slider from './Slider'
import './sliderStyle.scss'
const SliderContainer = () => {
  return (
    <div className='sliderClass'>
        <Slider />
    </div>
  )
}

export default SliderContainer